import { useEffect, useState } from "react";
import LocationNumber from "./LocationNumber";
import { sendMessage, listenToMessages } from "../../wsFunctions/socket";

function Tab1helperView() {
    // Get it from web request
    const [disabledQRCodeList, setDisabledQRCodeList] = useState([])
    const [category, setCategory] = useState("none");
    const [number, setNumber] = useState("");

    //Bytt til å endre hver gang ny webscoket req kommer inn
    useEffect(() => {
        const listner = listenToMessages((e) => {            
            if (e.data.type === "blocked-qr-codes-updated") {                
                setDisabledQRCodeList(e.data.data.BlockedQRCodes);
            };
        });

        sendMessage({type: "tab-1-opened", data: ''})
        return () => listner;
    }, []);
    const deactivate = () => { //Bytt til å sende til backend og reset input
        if (category === "none" || !number) {
            alert("Sørg for at sted og nummer er valgt.");
            
        } else if (disabledQRCodeList.some(info => (info.location[0] === category && info.location[1] === number))) {
            alert("QR-kode er allerede deaktivert.")
        } else {
            sendMessage({type: "blocked-qr-codes-append", data: {list: [category, number]}})
            setNumber("")
        };
    };

    const activate = (e) => {
        const id = JSON.parse(e.target.dataset.id);
        const category = id[0];
        const number = id[1];
        sendMessage({type: "blocked-qr-codes-remove", data: {list: [category, number]}});
    };

    return (
        <div>
            <div className="QRCode-form-container">
                <h1>Deaktiver QR-kode: </h1>
                <div className="QRCode-form">
                    <LocationNumber
                        number={number}
                        setNumber={setNumber}
                        category={category}
                        setCategory={setCategory}
                    />
                </div>
                <button onClick={deactivate}>Deaktiver QR-kode</button>
            </div>
            <div className="list-with-center">
                <h1>Deaktiverte QR-koder:</h1>
                <div className="deactivated-list">
                    {(disabledQRCodeList === undefined) ? '' : disabledQRCodeList.map((QRCodeInfo, i) => (
                        <div key={i} className="deactiveated-list-item">
                            <p>{QRCodeInfo.location[0]} {QRCodeInfo.location[1]}</p>
                            <p className="activate-btn" data-id={JSON.stringify([QRCodeInfo.location[0], QRCodeInfo.location[1]])} onClick={activate}>Aktiver QR-kode</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Tab1helperView;